
<ion-tabs>
  
  <ion-tab-bar slot="bottom">

    <ion-tab-button tab="dashboard" [disabled]="!isProfileCompleted" (click)="handleTabClick('dashboard', $event)">
      <ion-icon name="home-outline"></ion-icon>
      <ion-label>Home</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="profile" (click)="handleTabClick('profile', $event)">
      <ion-icon name="person-circle-outline"></ion-icon>
      <ion-label>Profile</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="hobbies" [disabled]="!isProfileCompleted" (click)="handleTabClick('hobbies', $event)">
      <ion-icon name="grid-outline"></ion-icon>
      <ion-label>Explore</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="myHobbies" [disabled]="!isProfileCompleted || !hasHobbies" (click)="handleTabClick('myHobbies', $event)">
      <ion-icon name="star-outline"></ion-icon>
      <ion-label>My Hobbies</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="matches" [disabled]="!isProfileCompleted || !hasHobbies" (click)="handleTabClick('matches', $event)">
      <ion-icon name="heart-outline"></ion-icon>
      <ion-label>Matches</ion-label>
    </ion-tab-button>
    
    <ion-tab-button *ngIf="isAdmin" tab="createHobby" (click)="handleTabClick('createHobby', $event)">
      <ion-icon name="add-circle-outline"></ion-icon>
      <ion-label>Add Hobby</ion-label>
    </ion-tab-button>

  </ion-tab-bar>
</ion-tabs>
